import { Auth } from 'aws-amplify';

/**
 * Obtains a Cognito access token for authenticated file and API requests. Asks Auth.currentSession for a JWT, retrying once on failure.
 *
 * @returns Promise resolving to the access token, or null when both attempts failed.
 */
const generateToken = async () => {
  let accessToken = null;
  try {
    accessToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
  } catch (error) {
    console.error('Failed to get access token: ', error);

    // *: Retry to get token if the first attempt fails
    try {
      accessToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
    } catch (retryError) {
      console.error('Failed to get access token on retry: ', retryError);
    }
  }

  return accessToken;
};

export default generateToken;
